import React, { forwardRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { Container, Header, Content, Footer, Sidebar as Side } from "rsuite";
import { Icon, Segment } from "semantic-ui-react";
import { api } from "../../../services/api";
import moment from "moment";
import {
  AddBox,
  ArrowDownward,
  Check,
  ChevronLeft,
  ChevronRight,
  Clear,
  DeleteOutline,
  Edit,
  FilterList,
  FirstPage,
  LastPage,
  Remove,
  SaveAlt,
  Search,
  ViewColumn,
  Visibility,
} from "@material-ui/icons";
import MaterialTable from "material-table";

import Navbarr from "../../../components/Navbar";

import "./styles.css";

export default function VisitList({ sidebar: Sidebar }) {
  const history = useHistory();

  const [isLoading, setIsLoading] = useState(false);
  const [lastUpdate, setLastUpdate] = useState("...");

  const columns = [
    {
      title: "Identificador",
      sorting: false,
      field: "id",
      sort: "desc",
      width: 50,
      editable: "never",
      type: "numeric",
      align: "center",
    },
    {
      title: "Promotor",
      sorting: false,
      field: "creator.nome",
      //sort: 'asc',
      width: 300,
      editable: "never",
      align: "left",
    },
    {
      title: "Loja",
      sorting: false,
      field: "loja.nome",
      //sort: 'asc',
      width: 300,
      editable: "never",
      align: "left",
    },
    {
      title: "Pontos Extras",
      sorting: false,
      field: "pontosExtra.imagensExtra.length",
      sort: "asc",
      width: 50,
      editable: "never",
      align: "center",
      type: "numeric",
      emptyValue: 0,
    },
    /*{
            title: 'Produtos',
            field: 'propriosQtd',
            sort: 'asc',
            width: 50
            editable: "never"
        },
        {
            title: 'Competidores',
            field: 'competidoresQtd',
            sort: 'asc',
            width: 50
            editable: "never"
        },*/
    {
      title: "Checkin",
      sorting: false,
      field: "checkin.date",
      //sort: 'asc',
      width: 300,
      editable: "never",
      type: "datetime",
      align: "center",
      dateSetting: { locale: "pt-br" },
    },
    {
      title: "Checkout",
      sorting: false,
      field: "checkout.date",
      //sort: 'asc',
      width: 300,
      editable: "never",
      type: "datetime",
      align: "center",
      emptyValue: "",
      dateSetting: { locale: "pt-br" },
    },
  ];

  const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => (
      <ChevronRight {...props} ref={ref} />
    )),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => (
      <ChevronLeft {...props} ref={ref} />
    )),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => (
      <ArrowDownward {...props} ref={ref} />
    )),
    ThirdStateCheck: forwardRef((props, ref) => (
      <Remove {...props} ref={ref} />
    )),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
  };

  const convertVisitDateToMoment = (visit) => {
    visit.checkin.date = moment(visit.checkin.date).format("llll");
    if (visit.checkout) {
      visit.checkout.date = moment(visit.checkout.date).format("llll");
    }
    return visit;
  };

  const dataQuery = (query) => {
    return new Promise(async (resolve, reject) => {
      setIsLoading(true);
      try {
        const { content, pageable, ...pageData } = await api.getVisits(
          query.page,
          query.pageSize,
          "id"
          // query.search
        );
        setLastUpdate(moment().subtract({ hours: 3 }).format("LT")); // Subtract 3 hours to show correctly for GMT-3
        content.forEach(convertVisitDateToMoment);
        return resolve({
          data: content, // your data array
          page: pageable.pageNumber, // current page number
          totalCount: pageData.totalElements, // total row number
        });
      } catch (err) {
        return reject(err);
      } finally {
        setIsLoading(false);
      }
    });
  };

  const goToVisitScreen = (e, visit, index) => {
    e.preventDefault();
    history.push(`/visits/${index}`, { visit: JSON.stringify(visit) });
  };

  return (
    <Container>
      <Side style={{ flex: "0 0 auto", width: "auto" }}>
        <Sidebar page={"visitlist"}></Sidebar>
      </Side>
      <Container>
        <Header>
          <Navbarr />
        </Header>
        <Content style={{ backgroundColor: "#FAFAFA", padding: "5px" }}>
          <Segment style={{ boxShadow: "0 0 0 0 rgba(255, 255, 255, 0)" }}>
            <MaterialTable
              title="Visitas"
              style={{
                backgroundColor: "none",
                boxShadow: "none",
                padding: 0,
                margin: 0,
              }}
              icons={tableIcons}
              isLoading={isLoading}
              columns={columns}
              options={{
                pageSize: 20,
                pageSizeOptions: [10, 20, 50],
                padding: "dense",
                actionsCellStyle: {
                  alignItems: "center",
                },
                search: false,
              }}
              actions={[
                {
                  icon: Visibility,
                  tooltip: "Visualizar visita",
                  onClick: (event, rowData) =>
                    goToVisitScreen(event, rowData, rowData.id),
                },
              ]}
              data={dataQuery}
              localization={{
                header: { actions: "Ações" },
                pagination: {
                  labelRowsPerPage: "Linhas",
                  firstTooltip: "Primeira página",
                  firstAriaLabel: "Primeira página",
                  nextTooltip: "Próxima página",
                  nextAriaLabel: "Próxima página",
                  previousTooltip: "Página anterior",
                  previousAriaLabel: "Página anterior",
                  lastTooltip: "Última página",
                  lastAriaLabel: "Última página",
                },
                body: {
                  emptyDataSourceMessage: "Sem resultados para exibir",
                },
              }}
            />
            <Segment.Inline
              style={{
                fontSize: "12px",
                color: "#b0b0b0",
                marginRight: "10px",
                marginLeft: "10px",
              }}
            >
              <Icon name="clock outline" />
              Atualizado em {lastUpdate}
              <Icon style={{ marginLeft: "15px" }} name="check" />
              {/* {data ? data["rows"].length : "0"} {elementsName} */}
            </Segment.Inline>
          </Segment>
        </Content>
        <Footer />
      </Container>
    </Container>
  );
}